var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoTrash = function SvgIcoTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m32 96 21.4 370.8c1.5 25.4 22.5 45.2 47.9 45.2h245.4c25.4 0 46.5-19.8 47.9-45.2L416 96z",
    style: {
      opacity: 0.4
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32H32C14.3 32 0 46.3 0 64s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96l-7.2-14.3C307.4 6.8 296.3 0 284.2 0z",
    className: "ico-trash_svg__fa-primary"
  })));
};
export default SvgIcoTrash;